import styled, { css } from 'styled-components';

import { PaletteColor } from '@utils/types';

import { IconProps } from './types';

export const StyledCustomIcon = styled.span<IconProps>`
  display: flex;
  align-items: center;
  ${(p) =>
    p.height &&
    css`
      height: ${p.height}px;
    `};
  svg {
    ${({ width, height, fontSize }) => css`
      font-size: ${fontSize}px;
      width: ${width}px;
      height: ${height}px;
    `};

    path {
      fill: ${({ fill }) => fill};
      fill: ${({ paletteColor, theme }) =>
        theme.palette[paletteColor as PaletteColor]};
    }

    transform: ${({ isOpen }) => (isOpen ? 'rotateX(180deg)' : 'rotate(0deg)')};
    line-height: 1;
    font-weight: normal;
    cursor: ${(p) => (p.clickable ? 'pointer' : undefined)};
  }
`;
